import React from "react";
import { useParams } from "react-router-dom";

import { courseSessionsApi } from "api";
import { useToaster } from "utils";
import { useCourseSessions } from "api/hooks/useCourseSessions";
import { PaziaLoader } from "components/atoms";
import { SessionFormValues, SessionsForm } from "./SessionsForm";

export type CourseSession = SessionFormValues & { name: string };
export const SessionsStep = (): JSX.Element | null => {
  const { courseId } = useParams();
  const { loading, data: sessions, isReady, refresh } = useCourseSessions(courseId);
  const { showSuccess, showInfo } = useToaster();

  const onSessionAdded = async (data: SessionFormValues) => {
    const request = {
      dateFrom: data.sessionFrom,
      dateTo: data.sessionTo,
      name: `Zjazd ${sessions.length + 1}`,
    };

    await courseSessionsApi.create(Number(courseId), request);
    showSuccess("Zjazdy zostały zapisane.");
    refresh();
  };

  const deleteSession = async (sessionId: number) => {
    await courseSessionsApi.delete(Number(courseId), sessionId);
    showInfo("Usunięto zjazd.");
    refresh();
  };

  if (loading) return <PaziaLoader position="center" />;
  return (
    <SessionsForm
      onSubmit={onSessionAdded}
      deleteSession={deleteSession}
      isReady={isReady}
      sessions={sessions}
      courseId={Number(courseId)}
      refreshSessions={refresh}
    />
  );
};
